export function computeSubscriptionDiscountedPrice(
  price: string,
  discountAmount: string | null | undefined,
  discountType: string | null | undefined,
): string | null {
  const basePrice = parseFloat(price);
  if (isNaN(basePrice)) {
    return null;
  }
  const amount = parseFloat(discountAmount ?? "0");
  if (isNaN(amount) || amount <= 0) {
    return null;
  }
  if (discountType === "percentage") {
    return Math.max(0, basePrice * (1 - amount / 100)).toFixed(2);
  }
  return Math.max(0, basePrice - amount).toFixed(2);
}
